import React, { useEffect, useRef, useState } from "react";
import { Modal, Button, Spinner, Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchAnnouncementById, fetchAnnouncementComments } from "../../../redux/slice/announcementsSlice";
import { toast } from "react-toastify";
import companyLogo from "../../../assets/img/company_logo.png";

export default function AnnouncementPreviewModal({
    show,
    onHide,
    announcementId,
    canEdit
}) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const hasFetched = useRef(false);

    const [showLikes, setShowLikes] = useState(false);
    const [showComments, setShowComments] = useState(false);
    const [commentText, setCommentText] = useState("");
    const [comments, setComments] = useState([]);
    const [loadingComments, setLoadingComments] = useState(false);

    const { selected, detailsLoading, error, commentsData, commentsLoading } = useSelector(
        (state) => state.announcements
    );
    const likeCount = selected?.likeCount
        ? Object.keys(selected.likeCount).length
        : 0;

    const commentCount = selected?.commentCount
        ?(selected.commentCount)
        : 0;
    useEffect(() => {
        console.log("Effect triggered===============", { show, announcementId });
        if (!show || !announcementId) return;
        if (hasFetched.current) return;
        hasFetched.current = true;
        dispatch(fetchAnnouncementById(announcementId));
    }, [show, announcementId, dispatch]);

    useEffect(() => {
        if (!show) {
            hasFetched.current = false;
        }
    }, [show]);

    const handleOpenComments = () => {
        setShowComments(true);
        if (announcementId) {
            dispatch(
                fetchAnnouncementComments({
                    id: announcementId,
                    page: 0,
                    size: 20
                })
            );
        }
    };
    let commentsContent;

    if (commentsLoading) {
        commentsContent = (
            <div className="text-center">
                <Spinner animation="border" size="sm" />
            </div>
        );
    } else if (commentsData?.content?.length > 0) {
        commentsContent = commentsData.content.map((comment) => (
            <div key={comment.id} className="mb-3 p-2 border-bottom emp-comments">
                <div className="fw-bold d-flex justify-content-between">
                    <p><strong>Employee</strong>: {comment.employeeName}</p>
                    <small className="text-muted">
                        <strong>Date</strong>: {new Date(comment.createdAt).toLocaleString()}
                    </small>
                </div>
                <p><strong>Comment</strong>: <small>{comment.comment}</small></p>

            </div>
        ));
    } else {
        commentsContent = (
            <p className="text-muted text-center">
                ---No comments available---
            </p>
        );
    }


    const handleEdit = () => {
        if (!canEdit) {
            toast.error("You don't have permission to edit announcements", { className: "toast-error-custom" });
            return;
        }

        if (!announcementId) {
            toast.error("Invalid announcement ID", { className: "toast-error-custom" });
            return;
        }

        onHide();
        navigate(`/admin/announcements/${announcementId}/edit`);
    };

    return (
        <>
            <Modal show={show} onHide={onHide} size="xl" centered className="policy-view-modal">
                {/* <Modal show={show} onHide={onHide} size="xl" centered scrollable className="policy-view-modal" > */}
                <Modal.Header>
                    <Modal.Title className="policy-header-title">
                        {detailsLoading ? "Loading..." : selected?.title || "Preview"}
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    {detailsLoading && (
                        <div className="text-center">
                            <Spinner animation="border" />
                        </div>
                    )}
                    {error && !detailsLoading && (
                        <p className="text-danger">---Error loading announcements---</p>
                    )}
                    {selected && !detailsLoading && (
                        <div>
                            <div className="preview-header d-flex justify-content-between align-middle">
                                <div className="header-logo">
                                    <img className="company-logo mb-3" src={companyLogo} alt="Logo" height="40" />
                                    <p>
                                        <strong>Status:</strong>{" "}
                                        <span className={`badge ${selected.status === "PUBLISHED" ? "bg-success" : selected.status === "SCHEDULED" ? "bg-warning text-dark" : "bg-secondary"}`} >
                                            {selected.status}
                                        </span>
                                    </p>
                                </div>

                                <div className="header-right">
                                    <p>
                                        <strong>Created By:</strong>{" "}
                                        {selected.createdByName || "-"}
                                    </p>
                                    <p>
                                        <strong>Created At:</strong>{" "}
                                        {selected.createdAt
                                            ? new Date(
                                                selected.createdAt
                                            ).toLocaleString()
                                            : "-"}
                                    </p>

                                    {selected.updatedAt && (
                                        <>
                                            <p>
                                                <strong>Updated By:</strong>{" "}
                                                {selected.updatedBy || "-"}
                                            </p>
                                            <p>
                                                <strong>Updated At:</strong>{" "}
                                                {new Date(
                                                    selected.updatedAt
                                                ).toLocaleDateString()}
                                            </p>
                                        </>
                                    )}

                                    <p>
                                        <strong>Publish At:</strong>{" "}
                                        {selected.publishAt
                                            ? new Date(
                                                selected.publishAt
                                            ).toLocaleString()
                                            : "-"}
                                    </p>
                                </div>
                            </div>
                            <div
                                id="policy-preview"
                                className="policy-preview"
                                dangerouslySetInnerHTML={{
                                    __html: selected.content || ""
                                }}
                            />
                        </div>
                    )}
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" className="btn-cancel-cta" onClick={onHide}>
                        Close
                    </Button>
                    <div className="engagement-fixed-bar d-flex justify-content-between align-items-center">
                        <button type="button" className="engagement-item-left engagement-btn" onClick={() => setShowLikes(true)}>
                            <i className="bi bi-heart-fill heart-icon"><sup>{likeCount}</sup></i>
                            <small className="ms-1">Likes</small>
                        </button>
                        <button type="button" className="engagement-item-right" onClick={handleOpenComments}>
                            <i className="bi bi-chat-left-text-fill comment-icon"><sup>{commentCount}</sup></i>
                            <small className="me-1">Comments</small>
                        </button>
                    </div>
                    {canEdit && (
                        <Button variant="primary" className="primary-btn ml-4 mt-0 pl-4 pr-4" onClick={handleEdit}>
                            Edit
                        </Button>
                    )}
                </Modal.Footer>
            </Modal>

            {/* Likes Modal */}
            <Modal show={showLikes} onHide={() => setShowLikes(false)} centered className="announcements-view-likes">
                <Modal.Header>
                    <Modal.Title className="announcements-header-title">
                        {detailsLoading ? "Loading..." : selected?.title || "Preview"}, <i className="bi bi-heart-fill heart-icon"><sup>{likeCount}</sup></i>
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body style={{ maxHeight: "400px", overflowY: "auto" }}>
                    {selected?.likeCount && Object.keys(selected.likeCount).length > 0 ? (
                        Object.entries(selected.likeCount).map(([email, name]) => (
                            <div key={email} className="user-row d-flex justify-content-between align-items-center border-bottom py-2">
                                <div>
                                    <i className="bi bi-person-circle me-2 mr-2"></i> 
                                    {name}
                                </div>
                                <small className="text-muted">{email}</small>
                            </div>
                        ))
                    ) : (
                        <p className="text-muted text-center">--- No likes ---</p>
                    )}
                </Modal.Body>
            </Modal>

            {/* Comments Modal */}
            <Modal show={showComments} onHide={() => setShowComments(false)} size="lg" centered className="announcements-view-comments">
                <Modal.Header>
                    <Modal.Title className="announcements-header-title">
                        {detailsLoading ? "Loading..." : selected?.title || "Preview"}, <i className="bi bi-chat-left-text-fill comment-icon"><sup> {commentsData?.totalElements || 0}</sup></i>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ maxHeight: "400px", overflowY: "auto" }}>
                    {commentsContent}
                </Modal.Body>
            </Modal>
        </>
    );
}